import { render, staticRenderFns } from "./StepQuizCheckbox.vue?vue&type=template&id=9478614a&scoped=true&lang=pug"
import script from "./StepQuizCheckbox.vue?vue&type=script&lang=ts"
export * from "./StepQuizCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./StepQuizCheckbox.vue?vue&type=style&index=0&id=9478614a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9478614a",
  null
  
)

export default component.exports